import React from 'react';
import { ApprovalType } from '@/types/api';
import { useAtom } from 'jotai';
import { approvalFilter } from '@/recoil/atom';
import { Container, StyledLabel } from './styles';
import Checkbox from '@/components/@IntranetLibrary/Checkbox';
import HighlightedText from '@/components/Approval/Common/HighlightedText';

type P = {
  filterName: 'types';
  isTarget?: boolean;
  index?: number;
  onMouseMove?(idx?: number): void;
  handleChange: (approval: ApprovalType) => void;
  /** 검색어 — 매칭 부분을 파랑으로 하이라이트 */
  keyword?: string;
};

const CheckBox = ({
  type,
  tag,
  name,
  sortNumber,
  filterName,
  isTarget,
  onMouseMove,
  index,
  handleChange,
  keyword,
}: ApprovalType & P) => {
  const [filters, setFilters] = useAtom(approvalFilter);

  const isChecked = filters[filterName].some(
    (res: ApprovalType) => res.type === type,
  );

  return (
    <Container
      className={'v2cb-hover-target'}
      tabIndex={index}
      isTarget={isTarget}
      onMouseMove={() => {
        onMouseMove && onMouseMove(index);
      }}
      onClick={() => handleChange({ type, tag, name, sortNumber })}
    >
      <Checkbox checked={isChecked} sx={{ padding: 0 }} />
      <StyledLabel>
        <HighlightedText text={name} keyword={keyword} />
      </StyledLabel>
    </Container>
  );
};

export default CheckBox;
